import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { actionTypes, useStateValue } from "../../../store";
import Header from "../BaseComponents/Header";
import HIFotterMain from "../BaseComponents/Footer";
import {
    GetBuyProductRequest,
  GetSellProductByCustomerRequestList,
  SellProductByCustomerOTPVerify,
  SellProductByCustomerRequestToMoreDealer,
  SellProductByCustomerToMoreDealer,
} from "../../../networkCalls";
import * as yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import ChatIcon from '@mui/icons-material/Chat';
import LoadingCellFullPage from "../../LoadingCell/LoadingCellFullPage";
import { Alert, Checkbox, FormGroup, Pagination, Tooltip, Typography, Card, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, Button, Table } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import { set } from "date-fns";
const MypurchasedProductEnquires = () => {
  const { pageSlug } = useParams();
  console.log("pageslug", pageSlug);
  const [show, setShow] = useState(false);
  const [dealer, setDealer] = useState({});
  const [selectedRequest, setSelectedRequest] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setDealer(data);
    setShow(true);
  };
  const [{ token, huid }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);
  const [orderlistData, setOrderlistData] = useState([]);

  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [dealererrMessage, setDealerErrMessage] = useState("");
  const [selected, setSelected] = useState([]);

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((d) => d.id !== id.id) : [...prev, id]
    );
  };
  const [Verificationshow, setVerificationShow] = useState(false);


  const checkOrderListData = () => {
    var data = new FormData();
    data.append("customerId", huid);
    // data.append("XAuth", token);
    setLoading(true);
    GetBuyProductRequest(data).then((res) => {
      console.log("data is", res.data);
      setLoading(false);
      switch (res.data.status) {
        case 1:
            setPageCount(res?.data?.products?.pagination);
          setOrderlistData(res?.data?.products?.list);

          return true;
        case 0:
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };
  useEffect(() => {
    checkOrderListData();
  }, [token, huid, dispatch, page, pageSlug]);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const navigate = useNavigate();
  const [otpverificationresponse, setOTPverificationRespoanse] = useState("");
  const [dealershow, setdealerShow] = useState(false);
  const [otpshow, setOTPShow] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [errMessage, setErrMessage] = useState("");
  // const [dealererrMessage, setDealerErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
 
  
  return (
    <>
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          <div className="innerpagebg pt-5 pb-5">
            <div className="container">
              <div className="d-flex  align-items-center gap-5 w-100">
                

                <div className="d-flex align-items-center justify-content-between w-75">
                  <h4 className=" text-center m-0 fw-bold text-uppercase">
                    <span className="texthivalueplus"> Product's </span>{" "}
                    <span className="txtdgray">
                      Enquiry ({orderlistData?.length})
                    </span>
                  </h4>
                  
                </div>

              </div>
            </div>
            <div className="container mt-3">
              <div className="row">
                <div className="col-lg-9 col-md-12 col-12 m-auto">
                  {orderlistData.length > 0 &&
                    <div className="table-responsive mt-4">
                      <table className="table table-bordered table-striped">
                        <thead class="">
                          <tr>
                            <th>Model Name</th>
                            <th>Dealer Name</th>
                            <th>Category</th>
                            <th>Request Status</th>
                            <th>View Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderlistData.map((val, id) => {
                            return (
                              <tr key={id} className="f13 ">
                                <td className="texthivalueplus fw500">
                                <Link to={`/hi-value-plus/product-detail/${val.productSlug}`} className="text-black text-decoration-none">

                                  {val.productName}
                                </Link>
                                </td>
                                <td>{val.dealername}</td>
                                <td>{val.category}</td>
                                <td>{val.request_status === 0 ? "Pending": val.request_status === 1 ? "Accepted":"Rejected"}</td>
                                <td >
                                  <div className="d-flex align-items-center gap-2">
                                    {
                                      val?.request_status !== 0  && (
                                        <Tooltip
                                          title="View Comments"
                                          placement="left"
                                          arrow
                                        >
                                          <Link
                                            className="text-black"
                                            onClick={() => {
                                              handleShow(val);
                                              setSelectedRequest("comments");
                                            }}
                                            to="#"
                                          >
                                            <ChatIcon />{" "}
                                          </Link>
                                        </Tooltip>)
                                    }
                                   </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
               {orderlistData.length > 0 && <div className="col-lg-9 col-md-12 col-12 d-flex justify-content-center m-auto">
                  <Pagination
                    color="error"
                    variant="outlined"
                    // shape="rounded"
                    count={pageCount}
                    page={page}
                    onChange={handleChange}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#0873bb", // text color for unselected
                        borderColor: "#0873bb", // border for outlined variant
                        "&:hover": {
                          backgroundColor: "rgba(8, 115, 187, 0.1)", // light blue hover
                        },
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#0873bb", // ✅ your base color for active background
                        color: "#fff", // white text
                        borderColor: "#0873bb",
                        "&:hover": {
                          backgroundColor: "#065f99", // slightly darker on hover
                          borderColor: "#065f99",
                        },
                      },
                    }}
                  />
                </div>}
              </div>
            </div>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedRequest ==="details" ?  "Dealer Details": "Dealer Comments"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-12 mb-1 f16 ">
            {dealer?.comment}
          </div>
          <div className="col-12 mb-2 f13 fw-semibold">Responed at: <span className="fw-normal">{dealer?.action_at}</span></div>
        
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Dealer list modal  */}
     

      <HIFotterMain />
    </>
  );
};

export default MypurchasedProductEnquires;
